/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult
 */
export interface JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult {
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult
     */
    isEmailAvailable?: boolean;
}

/**
 * Check if a given object implements the JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult interface.
 */
export function instanceOfJumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResultFromJSON(json: any): JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult {
    return JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResultFromJSONTyped(json, false);
}

export function JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isEmailAvailable': !exists(json, 'isEmailAvailable') ? undefined : json['isEmailAvailable'],
    };
}

export function JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResultToJSON(value?: JumboGetwizeremailavailabilityGetWizerEmailAvailabilityResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isEmailAvailable': value.isEmailAvailable,
    };
}

